/*
 * @Author: 张玉婷
 * @Date: 2022-03-22 10:49:55
 * @LastEditTime: 2022-03-22 11:17:07
 * @LastEditors: 张玉婷
 * @Description:
 * @FilePath: \air_version_2\src\utils\cesium\LayersModal\index.ts
 */

import * as Cesium from 'cesium';
import TdtLayer from '../tdtLayers';

export default class LayersModal extends Cesium.ProviderViewModel {
  constructor (name: string, tooltip: string, iconUrl: string, layers: string[]) {
    super({
      name,
      tooltip,
      iconUrl,
      creationFunction: () => layers.map((layer: any) => new TdtLayer(layer)),
    });
  }
}
